import { api } from './ApiService';

export const getWorklog = (id) => {
  return api.get(`/worklog/${id}`);
};
